import { cn, NoddiIcon } from 'noddi-ui-common';
import * as React from 'react';
import { NoddiToolTip } from '../molecules/NoddiToolTip';

const NoddiTextArea = React.forwardRef<
  HTMLTextAreaElement,
  React.ComponentProps<'textarea'> & {
    label?: string;
    tooltip?: string;
    error?: boolean;
  }
>(({ className, label, tooltip, error, ...props }, ref) => {
  const { name } = props;

  const labelIdentifier = `${name}_label`;

  return (
    <div>
      <label id={labelIdentifier} htmlFor={name} className='flex items-center gap-2'>
        {label}
        {tooltip && (
          <div className='mt-1.5'>
            <NoddiToolTip content={tooltip} position='top'>
              <NoddiIcon name='Info' size='sizeForChip' />
            </NoddiToolTip>
          </div>
        )}
      </label>

      <textarea
        className={cn(
          'flex min-h-[60px] w-full rounded-md border border-input bg-transparent px-3 py-2 text-base shadow-sm placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50 md:text-sm',
          className,
          error && 'border-danger'
        )}
        ref={ref}
        {...props}
      />
    </div>
  );
});
NoddiTextArea.displayName = 'NoddiTextArea';

export { NoddiTextArea };
